import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { MatchPaymentsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createMatchPayment = (data, callbackFunction): any => action(types.CREATE_MATCH_PAYMENT_REQUESTED, { data, callbackFunction });

export const updateMatchPayment = (data): any => action(types.UPDATE_MATCH_PAYMENT_REQUESTED, data);

export const deleteMatchPayment = (matchPaymentId): any => action(types.UPDATE_MATCH_PAYMENT_REQUESTED, matchPaymentId);

export const getMatchPayment = (matchPaymentId): any => action(types.GET_MATCH_PAYMENT_REQUESTED, matchPaymentId);

export const getAllMatchPayments = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_MATCH_PAYMENTS_REQUESTED, { pagination, compile });

export const selectMatchPayment = (matchPaymentId): any => action(types.SELECT_MATCH_PAYMENT_REQUESTED, {
  currentMatchPaymentId: matchPaymentId,
});

export const clearMatchPayments = (): any => action(types.CLEAR_MATCH_PAYMENTS);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createMatchPaymentPending: (payload): any => action(types.CREATE_MATCH_PAYMENT_PENDING, payload),
  createMatchPaymentSuccess: (response): any => action(types.CREATE_MATCH_PAYMENT_SUCCESS, {
    matchPaymentsById: response.entities.matchPayments,
    currentMatchPaymentId: response.result,
  }),
  updateMatchPaymentPending: (payload): any => action(types.UPDATE_MATCH_PAYMENT_PENDING, payload),
  updateMatchPaymentSuccess: (response): any => action(types.UPDATE_MATCH_PAYMENT_SUCCESS, {
    matchPaymentsById: response.entities.matchPayments,
    currentMatchPaymentId: response.result,
  }),
  updateMatchPaymentFailed: (error): any => action(types.UPDATE_MATCH_PAYMENT_FAIL, { backendErrors: error }),
  deleteMatchPaymentPending: (): any => action(types.UPDATE_MATCH_PAYMENT_PENDING, {}),
  deleteMatchPaymentSuccess: (response, userId): any => {
    localStorage.set(userId, { currentMatchPaymentId: null });
    history.push('/matchPayments');

    return action(types.DELETE_MATCH_PAYMENT_SUCCESS, {
      currentMatchPaymentId: response,
    });
  },
  getMatchPaymentPending: (): any => action(types.GET_MATCH_PAYMENT_PENDING, {}),
  getMatchPaymentSuccess: (response): any => action(types.GET_MATCH_PAYMENT_SUCCESS, {
    matchPaymentsById: response.entities.matchPayments,
    currentMatchPaymentId: response.result,
  }),
  getMatchPaymentFailed: (error): any => action(types.GET_MATCH_PAYMENT_FAIL, { backendErrors: error }),
  deleteMatchPaymentFailed: (error): any => action(types.UPDATE_MATCH_PAYMENT_FAIL, { backendErrors: error }),
  getAllMatchPaymentsPending: (pagination): any => action(types.GET_ALL_MATCH_PAYMENTS_PENDING, { pagination }),
  getAllMatchPaymentsSuccess: (response, meta): any => action(types.GET_ALL_MATCH_PAYMENTS_SUCCESS, {
    matchPaymentsById: response.entities.matchPayments,
    matchPaymentIds: response.result,
    meta,
  }),
  getAllMatchPaymentsFailed: (error): any => action(types.GET_ALL_MATCH_PAYMENTS_FAIL, { backendErrors: error }),
  createMatchPaymentFailed: (error): any => action(types.CREATE_MATCH_PAYMENT_FAIL, { backendErrors: error }),
};

export default {
  createMatchPayment,
  updateMatchPayment,
  deleteMatchPayment,
  getMatchPayment,
  getAllMatchPayments,
  selectMatchPayment,
};
